import { render, staticRenderFns } from "./taskEditor.vue?vue&type=template&id=1807d60a&scoped=true"
import script from "./taskEditor.vue?vue&type=script&lang=js"
export * from "./taskEditor.vue?vue&type=script&lang=js"
import style0 from "./taskEditor.vue?vue&type=style&index=0&id=1807d60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1807d60a",
  null
  
)

export default component.exports